import { EmployeeRolesEnum } from "@gtpl/shared-models/common-models";

export class EmployeeRoleRequest{
    employeeRole:EmployeeRolesEnum;
    
    constructor(employeeRole:EmployeeRolesEnum){
        this.employeeRole = employeeRole;
    }
}